import React from 'react';
import bemify from 'bemify-js';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

import { Duration } from '@zapier/theme';
import { Timeout } from '@zapier/common-components';

import Link from 'app/common/components/Link';
import Popover from 'app/common/components/Popover';
import PopoverMessage from 'app/common/components/PopoverMessage';
import 'app/beta-editor/components/formatic/FastChoice.scss';

const FastChoice = createReactClass({
  displayName: 'FastChoice',

  getInitialState() {
    return {
      isLabelPopoverOpen: false,
      isHoveringOverLabel: false,
      isSamplePopoverOpen: false,
      isHoveringOverSample: false,
    };
  },

  onMouseEnterSample() {
    this.setState({
      isHoveringOverSample: true,
    });
  },

  onOpenSamplePopover() {
    this.setState({
      isSamplePopoverOpen: true,
    });
  },

  onMouseLeaveSample() {
    this.setState({
      isSamplePopoverOpen: false,
      isHoveringOverSample: false,
    });
  },

  onMouseEnterLabel() {
    this.setState({
      isHoveringOverLabel: true,
    });
  },

  onOpenLabelPopover() {
    this.setState({
      isLabelPopoverOpen: true,
    });
  },

  onMouseLeaveLabel() {
    this.setState({
      isLabelPopoverOpen: false,
      isHoveringOverLabel: false,
    });
  },

  onSelect() {
    this.props.onSelect(this.props.choice);
  },

  render() {
    const { choice } = this.props;
    const bem = bemify('fast-choice');

    return (
      <Link onClick={this.onSelect} style={{ cursor: 'pointer' }}>
        <Popover>
          <span
            className={bem(`__label choice-label`)}
            onMouseEnter={this.onMouseEnterLabel}
            onMouseLeave={this.onMouseLeaveLabel}
          >
            {choice.label}
          </span>
          {this.state.isLabelPopoverOpen ? (
            <PopoverMessage>
              <span>{choice.label}</span>
            </PopoverMessage>
          ) : null}
        </Popover>
        <Popover>
          <span
            className={bem(`__sample choice-sample`)}
            onMouseEnter={this.onMouseEnterSample}
            onMouseLeave={this.onMouseLeaveSample}
          >
            {choice.sample}
          </span>
          {this.state.isSamplePopoverOpen ? (
            <PopoverMessage>
              <span>{choice.sample}</span>
            </PopoverMessage>
          ) : null}
        </Popover>
        <Timeout
          delay={Duration.tooltipTimeout.default}
          isWaiting={this.state.isHoveringOverLabel}
          onTimeout={this.onOpenLabelPopover}
        />
        <Timeout
          delay={Duration.tooltipTimeout.default}
          isWaiting={this.state.isHoveringOverSample}
          onTimeout={this.onOpenSamplePopover}
        />
      </Link>
    );
  },
});

export default FastChoice;
